import { useMemo } from "react";
import { useLanguageContext } from "../../../../context/LanguageContext";
import PaxtonVisitorTypesView from "./PaxtonVisitorTypesView";

function PaxtonVisitorTypes({
  configData,
  setConfigData,
  paxtonResources,
  visitorTypes,
}) {
  const { translateEntity } = useLanguageContext();

  const visitorTypeLabels = useMemo(() => {
    return visitorTypes.reduce((labels, visitorType) => {
      labels[visitorType.id] = translateEntity(visitorType, "label");
      return labels;
    }, {});
  }, [visitorTypes, translateEntity]);

  const availableVisitorTypes = useMemo(() => {
    return visitorTypes.filter((visitorType) => {
      return !configData.visitor_types.some(
        (configVisitorType) =>
          configVisitorType.visitor_type_id === visitorType.id,
      );
    });
  }, [visitorTypes, configData]);

  /**
   * This method will add a visitor type to the config data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeAdd(visitorTypeId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: [
        ...prev.visitor_types,
        {
          visitor_type_id: visitorTypeId,
          access_level_id: paxtonResources.access_levels?.[0]?.id,
        },
      ],
    }));
  }

  /**
   * This method will update a visitor type's property in the config data
   * @param {int} visitorTypeId
   * @param {string} key
   * @param {*} value
   */
  function onVisitorTypeChange(visitorTypeId, key, value) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.map((visitorType) =>
        visitorType.visitor_type_id === visitorTypeId
          ? { ...visitorType, [key]: value }
          : visitorType,
      ),
    }));
  }

  /**
   * This method will delete a visitor type from the config data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeDelete(visitorTypeId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.filter(
        (visitorType) => visitorType.visitor_type_id !== visitorTypeId,
      ),
    }));
  }

  return (
    <PaxtonVisitorTypesView
      availableVisitorTypes={availableVisitorTypes}
      visitorTypeLabels={visitorTypeLabels}
      configData={configData}
      paxtonResources={paxtonResources}
      onVisitorTypeAdd={onVisitorTypeAdd}
      onVisitorTypeChange={onVisitorTypeChange}
      onVisitorTypeDelete={onVisitorTypeDelete}
    />
  );
}

export default PaxtonVisitorTypes;
